var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackgroundTrim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4096 271"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3147.5 68.9C2667.6 134.3 1964.1 211 1654.4 215.4 1264 220.9 699.2 225.2 0 131.3v139.8h4096.3V.1c-357.1 19.3-651.5 28.2-948.8 68.8z"
  })));
}

export default SvgBackgroundTrim;